import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWave } from "@/hooks/useWave";
import React from "react";
import { getWaveDropEligibility } from "../dropEligibility";
import { WaveLeaderboardCurationEmptyState } from "./WaveLeaderboardCurationEmptyState";
import { WaveLeaderboardDefaultEmptyState } from "./WaveLeaderboardDefaultEmptyState";
import { WaveLeaderboardMemesEmptyState } from "./WaveLeaderboardMemesEmptyState";
interface WaveLeaderboardEmptyStateProps {
  readonly wave: ApiWave;
  readonly onCreateDrop?: (() => void) | undefined;
}
export const WaveLeaderboardEmptyState: React.FC<WaveLeaderboardEmptyStateProps> = t0 => {
  const $ = _c(15);
  const {
    onCreateDrop,
    wave
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = React.useContext(AuthContext);
  const {
    isMemesWave,
    isCurationWave,
    participation
  } = useWave(wave);
  const isLoggedIn = Boolean(connectedProfile?.handle);
  const t1 = Boolean(activeProfileProxy);
  let t2;
  if ($[0] !== isCurationWave || $[1] !== isLoggedIn || $[2] !== participation || $[3] !== t1) {
    t2 = getWaveDropEligibility({
      isLoggedIn,
      isProxy: t1,
      isCurationWave,
      participation
    });
    $[0] = isCurationWave;
    $[1] = isLoggedIn;
    $[2] = participation;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    canCreateDrop,
    restrictionMessage,
    restrictionLink
  } = t2;
  if (isMemesWave) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <WaveLeaderboardMemesEmptyState />;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (isCurationWave) {
    let t3;
    if ($[6] !== canCreateDrop || $[7] !== onCreateDrop || $[8] !== restrictionLink || $[9] !== restrictionMessage) {
      t3 = <WaveLeaderboardCurationEmptyState onCreateDrop={onCreateDrop} canCreateDrop={canCreateDrop} dropRestrictionMessage={restrictionMessage} dropRestrictionLink={restrictionLink} />;
      $[6] = canCreateDrop;
      $[7] = onCreateDrop;
      $[8] = restrictionLink;
      $[9] = restrictionMessage;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  let t3;
  if ($[11] !== canCreateDrop || $[12] !== onCreateDrop || $[13] !== restrictionMessage) {
    t3 = <WaveLeaderboardDefaultEmptyState onCreateDrop={onCreateDrop} canCreateDrop={canCreateDrop} dropRestrictionMessage={restrictionMessage} />;
    $[11] = canCreateDrop;
    $[12] = onCreateDrop;
    $[13] = restrictionMessage;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};